export default {
    API_BASE_URL: "https://api.optimocapital.in",
    API_BASE_URL_NEW: "https://napi.optimocapital.in",
    CUSTOMER_FORM_URL: "https://loan.optimocapital.in",
    optimo_whatsapp_number: '917996655510',
    WEBSOCKET_URL: "wss://4pk27tvl3c.execute-api.ap-south-1.amazonaws.com/prod",
    DIGIO_ENVIRONMENT: "production",
};